document.addEventListener("DOMContentLoaded", () => {
    const productInputs = document.querySelectorAll("[data-variant-buttons] [data-single-option-selector]");
    const productInputChecked = document.querySelector("[data-variant-buttons] [data-single-option-selector]:checked");
    const inquireBtn = document.querySelector("#ProductPopup-buttons");

    if (!inquireBtn) return;

    if (productInputChecked.classList.contains("sold-out")) {
        inquireBtn.setAttribute('disabled', 'disabled');
        inquireBtn.textContent = "Sold Out";
    } else {
        inquireBtn.removeAttribute('disabled');
        inquireBtn.textContent = "INQUIRE";
    }

    productInputs.forEach(input => {
        input.addEventListener("change", (e) => {
            if (e.target.classList.contains("sold-out")) {
                inquireBtn.setAttribute('disabled', 'disabled');
                inquireBtn.textContent = "Sold Out";
            } else {
                inquireBtn.removeAttribute('disabled');
                inquireBtn.textContent = "INQUIRE";
            }
        });
    });
});